<mat-dialog-content class="color-primary content-primary">
  <h2>{{ data.title }}</h2>
  <p class="message" [innerHTML]="data.message"></p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button color="primary" mat-dialog-close cdkFocusInitial>{{ data.button || 'OK' }}</button>
</mat-dialog-actions>
